export default __webpack_public_path__ + "static/media/mas-on-tour.e725bed7.png";